<template>
  <SharedTiles
    :title="mgnlProps.title"
    :title-color="mgnlProps.titleColor"
    :sub-title="mgnlProps.subTitle"
    :subtitle-color="mgnlProps.subtitleColor"
    :disable-shadow="mgnlProps.disableShadow"
    :items="mgnlProps.items"
    :image-load-type="mgnlProps.imageLoadType as ('eager' | 'lazy')"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { TilesBuilder, WrapperProps } from '~/components/Shared/Tiles/Tiles.model';

const props = defineProps(WrapperProps);

const mgnlProps = TilesBuilder.build(props);
</script>
